import React, { FunctionComponent } from 'react';
import { Scout, PersonShowModalScoutListStateProps, Favorite, Entry } from '../../../types/personShow';

type Props = {
  state: PersonShowModalScoutListStateProps;
  handleClick: (target: 'favorites' | 'entries' | 'scouts') => void;
  handleSmallModalOpen: () => void;
  handleSetScout: (
    event: React.MouseEvent<HTMLAnchorElement>,
    item: Scout | Favorite | Entry
  ) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  handleClick,
  handleSmallModalOpen,
  handleSetScout,
}) => {
  const { list, favorites, entries, scouts, isSmallModal, scoutCreatedAt, scoutTitle, scoutMessage } = state;

  const renderHistories = (items: Scout[] | Favorite[] | Entry[], path: string) => (
    <div className="person__show__histories__item__inner">
      {items.length > 0 ? (
        items.map((item) => {
          const key = 'recruitmentId' in item ? item.recruitmentId : item.id;
          const href =
            'recruitmentId' in item
              ? `/${path}/${item.recruitmentId}`
              : 'messageBoxId' in item
                ? `/${path}/${item.messageBoxId}`
                : '#';
          return (
            <a
              key={key}
              onClick={(event) => handleSetScout(event, item)}
              href={href}
              className="person__show__histories__item--list"
            >
              <p className="person__show__histories__item--list--time">
                {item.createdAt}
                {'isApplied' in item && item.isApplied && (
                  <span className="person__show__histories__item--list--content--applied">応募済み</span>
                )}
              </p>
              <p className="person__show__histories__item--list--content">{item.title}</p>
            </a>
          );
        })
      ) : (
        <p className="person__show__histories__item--list">履歴はまだありません</p>
      )}
    </div>
  );

  const renderCount = () => {
    const counts: { [key: string]: string } = {
      favorites: `${favorites.length}件の履歴`,
      scouts: `${scouts.length}件の履歴`,
      entries: `${entries.length}件の履歴`,
    };
    return <p className="person__show__modal__inner__count">{counts[list]}</p>;
  };

  return (
    <>
      <div className="person__show__modal__inner">
        <div className="person__show__modal__inner__location__wrapper histories">
          <ul className="person__show__modal__inner__location">
            <li className={list === 'favorites' ? 'selected' : ''} onClick={() => handleClick('favorites')}>求人保存</li>
            <li className={list === 'scouts' ? 'selected' : ''} onClick={() => handleClick('scouts')}>スカウト</li>
            <li className={list === 'entries' ? 'selected' : ''} onClick={() => handleClick('entries')}>応募</li>
          </ul>
          {renderCount()}
          {list === 'favorites' && renderHistories(favorites, 'recruitments')}
          {list === 'scouts' && renderHistories(scouts, 'scouts')}
          {list === 'entries' && renderHistories(entries, 'management/messages')}
        </div>
      </div>

      <div className={`person__show__modal ${isSmallModal ? 'active' : ''}`}>
        <h3 className="person__show__modal__title">
          <div onClick={handleSmallModalOpen} className="mask">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F" />
            </svg>
          </div>
          <p className="title">スカウト詳細</p>
        </h3>
        <div className="person__show__modal__inner">
          <div className="person__show__modal__inner__scout">
            <p className="semiTitle">送信日</p>
            <p className="body">{scoutCreatedAt}</p>
          </div>
          <div className="person__show__modal__inner__scout">
            <p className="semiTitle">求人タイトル</p>
            <p className="body">{scoutTitle}</p>
          </div>
          <div className="person__show__modal__inner__scout">
            <p className="semiTitle">スカウト内容</p>
            <div dangerouslySetInnerHTML={{ __html: scoutMessage }} className="body" />
          </div>
        </div>
      </div>
    </>
  );
};
